import React from "react";
import "./index.scss";

interface SectionTitleProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  background?: string;
  color?: string;
  isTitlePage?: boolean;
}

const SectionTitle: React.FC<SectionTitleProps> = ({
  title,
  subtitle,
  background,
  color,
  isTitlePage = false,
}) => {
  const styleColor: React.CSSProperties = {
    color: color,
  };

  const styleHighlight: React.CSSProperties = {
    backgroundColor: background,
    height: "5px",
    width: "75%",
    left: "50%",
    position: "absolute" as const,
    transform: "translateX(-50%)",
  };

  const styleTitle: React.CSSProperties = {
    fontSize: isTitlePage ? "24px" : "30px",
    fontFamily: isTitlePage ? "Noto Sans JP" : "Jost",
    fontWeight: "bold",
    lineHeight: isTitlePage ? "24px" : "30px",
    marginBottom: isTitlePage && "4.5px",
  };

  const styleSubTitle: React.CSSProperties = {
    fontFamily: "Noto Sans JP",
    fontWeight: 400,
    fontSize: "14px",
    marginTop: isTitlePage ? "11px" : "4px",
    display: "flex",
    justifyContent: "center",
  };

  return (
    <div className="section-title" style={styleColor}>
      <div style={styleTitle}>{title}</div>
      <div style={styleHighlight}></div>
      <div style={styleSubTitle}>{subtitle}</div>
    </div>
  );
};

export default SectionTitle;
